import { useQuery } from 'react-query'
import {getConnectionLOg} from "app/axios/connectionLogApi";

export const useGetConnectionLog = (params:{}) => {
  return useQuery(['connection_log', params],
    () => getConnectionLOg(params)
  ) as any
}